import { PlannedHours, TransformedPlannedHours, WorkActivity } from '../redux/reducers/scheduleDateSlice'

export function transformResponseToWorkActivity(responseData: {
  plannedHours: PlannedHours
  trackedHours: PlannedHours
}): WorkActivity {
  const convertToArray = (obj: PlannedHours): TransformedPlannedHours[] => {
    return Object.entries(obj).map(([date, timeSlots]) => ({
      date,
      timeSlots,
    }))
  }

  return {
    plannedHours: convertToArray(responseData.plannedHours),
    trackedHours: convertToArray(responseData.trackedHours),
  }
}
